import { TelemetryInitializerFunction } from '@microsoft/applicationinsights-core-js';

export const staticFileFilter: TelemetryInitializerFunction = envelope => {
  const staticFileExtensions = ['.css', '.js', '.jpg', '.png', '.gif', '.json', '.ico', '.woff2', '.ttf'];
  if (envelope!.data!.baseType === 'RequestData') {
    let requestData = envelope.data!;
    let extension = requestData.name.substr(requestData.name.lastIndexOf('.'));
    if (staticFileExtensions.indexOf(extension) > -1) {
      return false;
    }
  }

  return true;
};
